<template>
    <cs-channel-teaser
        :data-component="$options.name"
        :channel="channel"
        :href="linkAttributes?.href"
        :target="linkAttributes?.target"
        :rel="linkAttributes?.rel"
    >
        <template
            v-if="image && image.computedProperties"
            #image
        >
            <img
                class="object-cover w-full"
                :src="image?.computedProperties.url"
                :alt="image?.binaryAltText"
            />
        </template>
        <template #text>
            <span
                v-if="countText"
                data-jest="countText"
            >
                {{ countText }}
            </span>
            <ms-text
                v-else-if="cmsTextContent"
                data-jest="cmsText"
                :contentTag="cmsTextContent"
            ></ms-text>
        </template>
    </cs-channel-teaser>
</template>
<script lang="ts" src="./M_ChannelTeaser.ts" />
